import Layout from '../Layout'
import SidebarLayout from '../Layout/Sidebar'
import MainLayout from '../Layout/Main'
import Sidebar from './Sidebar'

const PageLayout = (props) => {
  const { children } = props
  return (
    <Layout>
      <SidebarLayout>
        <Sidebar />
      </SidebarLayout>
      <MainLayout>
        {children}
      </MainLayout>
    </Layout>
  )
}

export default PageLayout
